import type { TFunction } from "i18next";
import { z } from "zod";

export const createForgotPasswordSchema = (t: TFunction) =>
  z.object({
    email: z
      .string({ error: t("auth.email_required") })
      .trim()
      .min(1, t("auth.email_required"))
      .email(t("auth.email_invalid")),
  });

export type ForgotPasswordSchema = ReturnType<typeof createForgotPasswordSchema>;
export type ForgotPasswordFormValues = z.output<ForgotPasswordSchema>;
